module.exports = __webpack_public_path__ + "img/c4.28df0d60.png";